/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import ClockIcon from '../../../assets/img/icon-clock.svg';
import sendAnalitycs from '../../../../domain/utils/utilitarios-frontend-coopeuch/Analytics';
import dataLayerObject from '../../../../domain/utils/dataLayerObject';

import StyledClockHelper from './styles';

const variationByMode = {
  chronometer: 1,
  timer: -1,
};

const Clock = (props) => {
  const [hasSentAnalytics, setHasSentAnalytics] = useState(false);
  const { time } = props;
  const parseToSeconds = (t) => {
    /* istanbul ignore next */
    if (t === -1) return 0;
    /* istanbul ignore next */
    if (t < 60) return t;
    return t % 60; // COMMENT: if(t >= 60)
  };
  const parseToMinutes = (t) => (t < 60 ? 0 : parseInt(t / 60, 10));
  const formatTime = (timeToFormat) => (timeToFormat < 10 ? `0${timeToFormat}` : `${timeToFormat}`);
  /* istanbul ignore next */
  useEffect(() => {
    if (time === 0 && !hasSentAnalytics) {
      sendAnalitycs(dataLayerObject.BORDE_SEND_SMS_TIME_OVER);
      setHasSentAnalytics(true);
    }
  }, [time, hasSentAnalytics]);

  return (
    <>
      <span className="ClockHelper__minutes">{formatTime(parseToMinutes(time))}</span>
      <span className="ClockHelper__seconds">{formatTime(parseToSeconds(time))}</span>
    </>
  );
};

const ClockHelper = (props) => {
  const { mode, initialTime, finalTime, objectMessage, onTimeOver, onRetry } = props;
  const [iterator, setIterator] = useState(null);
  const [time, setTime] = useState(initialTime);
  /* istanbul ignore next */
  const timeVariation = variationByMode[mode] || 1;

  const startIterator = () => {
    return setInterval(() => setTime((timeEle) => timeEle + timeVariation), 1000)
  };

  useEffect(() => {
    // return clearInterval(iterator);
    return () => {
      clearInterval(iterator);
    };
  }, []);
  /* istanbul ignore next */
  useEffect(() => {
    if (initialTime > -1) {
      setTime(initialTime);
      setIterator(startIterator());
    } else if (initialTime === -1) {
      setTime(-1);
      clearInterval(iterator);
    }
    return clearInterval(iterator);
  }, [initialTime]);

  useEffect(() => {
    if (time === 0 || (finalTime && time === finalTime)) {
      clearInterval(iterator);
      onTimeOver();
    }
  }, [time]);

  const handleClickRetry = () => {
    onRetry();
  };

  return (
    <>
      {objectMessage.visible && (
        <StyledClockHelper
          messageTextColor={objectMessage.textColor}
          buttonTextColor={objectMessage.button.textColor}
        >
          <article className="clock-helper-icon">
            <img src={ClockIcon} alt="clock" />
          </article>
          <p className="clock-helper-content">
            <>
              {initialTime !== -1 && (
                <span className="clock-helper-time">
                  <Clock time={time} />
                </span>
              )}
              {objectMessage.visible && (
                <>
                  <span className="clock-helper__text">{objectMessage.text}</span>
                  {objectMessage.button.visible && (
                    <button
                      onClick={handleClickRetry}
                      className="clock-helper__btn--retry"
                      type="button"
                    >
                      {objectMessage.button.text}
                    </button>
                  )}
                </>
              )}
            </>
          </p>
        </StyledClockHelper>
      )}
    </>
  );
};
/* istanbul ignore next */
ClockHelper.defaultProps = {
  mode: 'timer',
  initialTime: 0,
  finalTime: 3600,
  objectMessage: {},
  onTimeOver: () => {},
  onRetry: () => {},
};

ClockHelper.propTypes = {
  mode: PropTypes.string,
  initialTime: PropTypes.number,
  finalTime: PropTypes.number,
  objectMessage: PropTypes.shape({
    visible: PropTypes.bool,
    text: PropTypes.string,
    textColor: PropTypes.string,
    button: PropTypes.shape({
      visible: PropTypes.bool,
      text: PropTypes.string,
      textColor: PropTypes.string,
    }),
  }),
  onTimeOver: PropTypes.func,
  onRetry: PropTypes.func,
};

export default ClockHelper;
